import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { UseMutationOptions } from '@/types/queries'

export function useCancelLocalPqRunMutation(options?: UseMutationOptions<void, string>) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (runId: string) => pqClient.cancelRun(runId),
  })

  return { cancelRun: mutateAsync, ...mutationResult }
}
